import script from "./CreatePrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePrompt.vue?vue&type=script&setup=true&lang=js"

import "./CreatePrompt.vue?vue&type=style&index=0&id=862fcf2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-862fcf2c"]])

export default __exports__